export const assessments = {
  week1: {
    title: "Post Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: "A",
        type: "reflection",
        question:
          "What is one mindset shift you are taking away from this week?",
      },
      {
        id: "B",
        type: "reflection",
        question:
          "Think about your classroom. \nWhat is one small adjustment you could make to better support a learner who struggles?",
      },
      {
        id: 1,
        question:
          "Which educational practice involves placing all students in the same physical classroom but expects learners with special needs to change their behavior or learning style without providing systemic support?",
        options: [
          { id: "A", text: "Inclusion" },
          { id: "B", text: "Equity" },
          { id: "C", text: "Segregation" },
          { id: "D", text: "Integration" },
        ],
        correctOption: "D",
      },
      {
        id: 2,
        question: "The central concept of Inclusion is fundamentally about:",
        options: [
          {
            id: "A",
            text: "Placing struggling learners and average learners in the same classroom",
          },
          {
            id: "B",
            text: "Ensuring every learner is supported to participate fully in a way that values their contribution",
          },
          {
            id: "C",
            text: "Giving all students the exact same set of learning materials and resources",
          },
          {
            id: "D",
            text: "Identifying a learner's current ability level and placing them in the correct academic track",
          },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "A teacher provides a student with dyslexia a text-to-speech audio version of a novel, while the rest of the class reads the print version. This approach is an example of:",
        options: [
          {
            id: "A",
            text: "Integration, because the student is adapting to the teacher's lesson",
          },
          {
            id: "B",
            text: "Equality, because all students are working on the same novel",
          },
          {
            id: "C",
            text: "Equity, because the resources were adjusted to meet the specific needs of the learner",
          },
          {
            id: "D",
            text: "Segregation, because the student is using a different tool",
          },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "What is the primary goal of recognizing and grouping learners into the six Special Educational Needs (SEN) categories?",
        options: [
          {
            id: "A",
            text: "To effectively understand the barriers a child faces and determine the appropriate support strategies",
          },
          {
            id: "B",
            text: "To strictly adhere to government labeling and diagnosis protocols",
          },
          {
            id: "C",
            text: "To compare a learner's performance against the national average standards",
          },
          {
            id: "D",
            text: "To justify the removal of a learner from the mainstream classroom setting",
          },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          "Which of the following educational practices is explicitly defined as harmful to both students and society at large and is characterized by separating learners based on their perceived abilities?",
        options: [
          { id: "A", text: "Segregation" },
          { id: "B", text: "Integration" },
          { id: "C", text: "Equality" },
          { id: "D", text: "Tracking" },
        ],
        correctOption: "A",
      },
    ],
  },
  week2: {
    title: "Week 2 Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question: "Empathy in teaching is best described as:",
        options: [
          { id: "A", text: "Feeling sorry for learners who struggle" },
          {
            id: "B",
            text: "Understanding what a learner is experiencing and responding thoughtfully",
          },
          { id: "C", text: "Agreeing with all learner behaviors" },
          { id: "D", text: "Being emotionally attached to students" },
        ],
        correctOption: "B",
      },
      {
        id: 2,
        question: "Which teacher response best shows compassion in practice?",
        options: [
          {
            id: "A",
            text: "This child is difficult, so I will send them out of class",
          },
          { id: "B", text: "The rules are the rules, no exceptions" },
          {
            id: "C",
            text: "Let me understand what is causing this behavior and adjust my approach",
          },
          {
            id: "D",
            text: "I will ignore the behavior and hope it stops",
          },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question: "A strengths based approach means that teachers:",
        options: [
          { id: "A", text: "Focus mainly on what learners cannot do" },
          { id: "B", text: "Compare learners to each other" },
          {
            id: "C",
            text: "Identify and build on what learners do well",
          },
          { id: "D", text: "Avoid addressing weaknesses" },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question: "Why is self reflection important for inclusive teaching?",
        options: [
          {
            id: "A",
            text: "It helps teachers justify their existing beliefs",
          },
          {
            id: "B",
            text: "It helps uncover hidden biases and expectations",
          },
          { id: "C", text: "It replaces professional training" },
          { id: "D", text: "It focuses only on teacher emotions" },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question: "Viewing behavior through a developmental lens means:",
        options: [
          {
            id: "A",
            text: "Assuming children misbehave intentionally",
          },
          {
            id: "B",
            text: "Responding the same way to all age groups",
          },
          {
            id: "C",
            text: "Understanding that behavior is often a form of communication",
          },
          {
            id: "D",
            text: "Expecting children to self regulate without guidance",
          },
        ],
        correctOption: "C",
      },
    ],
  },
  week3: {
    title: "Week 3 Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: "A",
        type: "reflection",
        question:
          "Think about one lesson you recently taught. What is one small change you could make to make that lesson more inclusive?",
      },
      {
        id: 1,
        question:
          "Which statement best describes Universal Design for Learning in relation to SEND learners?",
        options: [
          {
            id: "A",
            text: "Designing one standard lesson and adjusting it only after SEND learners struggle",
          },
          {
            id: "B",
            text: "Designing lessons specifically for SEND learners and separate lessons for others",
          },
          {
            id: "C",
            text: "Designing lessons with built in flexibility so different learners can engage, understand, and express learning",
          },
          {
            id: "D",
            text: "Reducing learning expectations so SEND learners can cope",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question:
          "Why do many SEND learners struggle in traditional classrooms?",
        options: [
          { id: "A", text: "Because they lack motivation" },
          {
            id: "B",
            text: "Because lessons are often designed for one type of learner",
          },
          {
            id: "C",
            text: "Because SEND learners require separate classrooms",
          },
          {
            id: "D",
            text: "Because SEND learners cannot meet academic standards",
          },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question: "Which practice best supports engagement for SEND learners?",
        options: [
          {
            id: "A",
            text: "Frequently changing lesson routines to keep things exciting",
          },
          {
            id: "B",
            text: "Clear routines, visual schedules, and predictable transitions",
          },
          { id: "C", text: "Allowing behaviour to go unchecked" },
          { id: "D", text: "Avoiding challenging tasks entirely" },
        ],
        correctOption: "B",
      },
      {
        id: 4,
        question:
          "A learner with dyslexia understands content but struggles with reading tasks. Which UDL strategy best supports them?",
        options: [
          { id: "A", text: "Removing reading tasks altogether" },
          {
            id: "B",
            text: "Offering audio support or text to speech tools",
          },
          {
            id: "C",
            text: "Expecting the learner to read faster with practice",
          },
          { id: "D", text: "Giving the learner less content to learn" },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Which assessment option is most inclusive for SEND learners?",
        options: [
          {
            id: "A",
            text: "One timed written test for all learners",
          },
          {
            id: "B",
            text: "Allowing learners to demonstrate understanding through writing, oral responses, or visuals",
          },
          {
            id: "C",
            text: "Removing assessment for SEND learners",
          },
          { id: "D", text: "Lowering assessment standards" },
        ],
        correctOption: "B",
      },
    ],
  },
  week4: {
    title: "Week 4 Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "A student struggles to copy from the board; written work is minimal and poorly spaced; complains of hand pain during writing tasks.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "D",
      },
      {
        id: 2,
        question:
          "A student frequently leaves their seat, interrupts others, forgets instructions, and loses materials despite reminders.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "B",
      },
      {
        id: 3,
        question:
          "A student avoids reading aloud; reads very slowly; reverses letters; performs better in oral discussions than written work.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "C",
      },
      {
        id: 4,
        question:
          "A student becomes extremely upset when routines change; struggles with group work; avoids eye contact and prefers working alone.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "A",
      },
      {
        id: 5,
        question:
          "A student takes longer than peers to understand instructions; needs repeated guidance; becomes frustrated with complex tasks.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "E",
      },
      {
        id: 6,
        question:
          "A student has strong ideas but avoids written tasks; handwriting is illegible; written output does not match verbal understanding.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "D",
      },
      {
        id: 7,
        question:
          "A student stares blankly during verbal instructions; starts tasks late; performs better when instructions are broken into short steps.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "B",
      },
      {
        id: 8,
        question:
          "A student talks excessively, blurts out answers, and struggles to wait for turns.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question:
          "A student avoids copying notes; leaves work incomplete; asks to go to the toilet during writing-heavy lessons.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "D",
      },
      {
        id: 10,
        question:
          "A student appears socially isolated; struggles to understand jokes or sarcasm; takes instructions very literally.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "A",
      },
      {
        id: 11,
        question:
          "A student has difficulty remembering letter sounds; struggles with spelling even common words; avoids reading tasks.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "C",
      },
      {
        id: 12,
        question:
          "A student appears confused by abstract instructions; needs concrete examples; struggles with problem-solving tasks.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "E",
      },
      {
        id: 13,
        question:
          "A student melts down during transitions, especially from break time to class; resists lining up or sitting quietly.",
        options: [
          { id: "A", text: "Autism Spectrum Disorder" },
          { id: "B", text: "ADHD" },
          { id: "C", text: "Dyslexia" },
          { id: "D", text: "Dysgraphia" },
          { id: "E", text: "Intellectual Disability" },
        ],
        correctOption: "A",
      },
    ],
  },
  week5: {
    title: "Week 5 Assessment",
    subtitle: "Let's test your knowledge",
    questions: [
      {
        id: 1,
        question:
          "Which statement best explains why collaboration is essential in inclusive education?",
        options: [
          { id: "A", text: "Teachers are legally required to involve parents" },
          {
            id: "B",
            text: "Inclusion works best when teachers manage everything independently",
          },
          {
            id: "C",
            text: "Learners benefit when home and school responses are consistent",
          },
          {
            id: "D",
            text: "Collaboration reduces the teacher’s workload entirely",
          },
        ],
        correctOption: "C",
      },
      {
        id: 2,
        question:
          "When speaking with parents about learning or behaviour concerns, which approach is most effective?",
        options: [
          { id: "A", text: "Listing all the child’s challenges immediately" },
          { id: "B", text: "Using diagnostic labels to sound professional" },
          {
            id: "C",
            text: "Positioning yourself as a partner and using inclusive language",
          },
          { id: "D", text: "Avoiding the conversation to prevent conflict" },
        ],
        correctOption: "C",
      },
      {
        id: 3,
        question:
          "Which phrase best reflects strength-based communication with parents?",
        options: [
          { id: "A", text: "Your child always struggles to focus" },
          { id: "B", text: "Your child needs to try harder" },
          { id: "C", text: "Your child’s behaviour is a serious problem" },
          {
            id: "D",
            text: "I’ve noticed your child is curious, and we can build on that to support learning",
          },
        ],
        correctOption: "D",
      },
      {
        id: 4,
        question:
          "Which of the following best describes an Individualized Education Plan (IEP)?",
        options: [
          { id: "A", text: "A punishment plan for learners who misbehave" },
          {
            id: "B",
            text: "A flexible plan that supports participation based on learner needs",
          },
          { id: "C", text: "A document created only by the teacher" },
          { id: "D", text: "A medical diagnosis document" },
        ],
        correctOption: "B",
      },
      {
        id: 5,
        question:
          "Why is consistency between home and school especially important for SEND learners?",
        options: [
          { id: "A", text: "It reduces the teacher’s authority" },
          { id: "B", text: "It prevents confusion and emotional insecurity" },
          { id: "C", text: "It guarantees academic success" },
          { id: "D", text: "It removes the need for classroom adjustments" },
        ],
        correctOption: "B",
      },
      {
        id: 6,
        question:
          "Which response best reflects appropriate teacher language when discussing concerns?",
        options: [
          { id: "A", text: "Tolu has attention issues" },
          { id: "B", text: "Tolu never completes work" },
          {
            id: "C",
            text: "I’ve noticed Tolu struggles to stay engaged during long tasks",
          },
          { id: "D", text: "Tolu needs medication" },
        ],
        correctOption: "C",
      },
      {
        id: 7,
        question: "Which situation best demonstrates equity in the classroom?",
        options: [
          { id: "A", text: "Giving every learner the same worksheet" },
          {
            id: "B",
            text: "Lowering expectations for learners with difficulties",
          },
          {
            id: "C",
            text: "Providing multiple ways for learners to engage and show understanding",
          },
          { id: "D", text: "Removing challenging tasks entirely" },
        ],
        correctOption: "C",
      },
      {
        id: 8,
        question: "Which is an early warning sign of teacher burnout?",
        options: [
          { id: "A", text: "Feeling tired after a long day" },
          {
            id: "B",
            text: "Emotional numbness and withdrawal from colleagues",
          },
          { id: "C", text: "Enjoying quiet time after work" },
          { id: "D", text: "Asking for support from colleagues" },
        ],
        correctOption: "B",
      },
      {
        id: 9,
        question:
          "Which strategy helps prevent burnout in inclusive classrooms?",
        options: [
          { id: "A", text: "Taking full responsibility for every learner" },
          { id: "B", text: "Ignoring difficult emotions" },
          {
            id: "C",
            text: "Using structure, collaboration, and clear boundaries",
          },
          { id: "D", text: "Expecting immediate results" },
        ],
        correctOption: "C",
      },
      {
        id: 10,
        question: "Which statement best captures inclusive teaching success?",
        options: [
          { id: "A", text: "A completely silent classroom" },
          { id: "B", text: "Zero behavioural challenges" },
          {
            id: "C",
            text: "Small, consistent progress over time among SEND learners",
          },
          { id: "D", text: "Completing the syllabus at all costs" },
        ],
        correctOption: "C",
      },
    ],
  },
};
